<div class="signature-container">
  <canvas #canvas></canvas>
</div>
